import { createFileRoute } from '@tanstack/react-router'
import { GuideViewPage } from '~/pages/docs/guide-view-page'

export const Route = createFileRoute('/docs/guide/$slug/preview')({
  component: RouteComponent,
})

function RouteComponent() {
  const { slug } = Route.useParams()
  
  return (
   <GuideViewPage slug={slug} preview={true} />
  )
}
